const PsikotesFooter = () => {
  return (
    <>
      <footer className="footer footer-center p-5 bg-[#F2F2F2] text-gray-400 absolute">
        <div>
          <p className="">EVER SHINE GROUP</p>
          <p></p>
        </div>
      </footer>
    </>
  );
};

export default PsikotesFooter;
